// extracted by mini-css-extract-plugin
export default {"bgBlue":"styles_bgBlue__AAlQK","logo":"styles_logo__3hoQP"};